import { render, staticRenderFns } from "./CrossSellingRelease.vue?vue&type=template&id=11bfe742&"
import script from "./CrossSellingRelease.vue?vue&type=script&lang=js&"
export * from "./CrossSellingRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports